import { tableColumnsType } from '../components/edit-table/editable-table';

export interface PersonnelDetails {
  address1: string;
  address2: string;
  address3: string;
  companyId: string | null;
  companyName: string;
  contactNo1: string;
  contactNo2: string;
  continent: string;
  country: string;
  department: string;
  designation: string;
  entityName: string | null;
  entityCode: string;
  flagInternal: number;
  flagInternalLabel?: string;
  id: string;
  isActive: boolean;
  personnelEmail: string;
  personnelName: string;
  province: string;
  remarks: string;
  state: string;
  zipCode: string;
}

const allPersonnelColumns = (): tableColumnsType[] => {
  return [
    {
      Header: 'Id',
      accessor: 'id',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Company Id',
      accessor: 'companyId',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Company Name',
      accessor: 'companyName',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'SMS User/Customer',
      accessor: 'flagInternalLabel',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Entity',
      accessor: 'entityCode',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Personnel Name',
      accessor: 'personnelName',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Designation',
      accessor: 'designation',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Department',
      accessor: 'department',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Address Line 1',
      accessor: 'address1',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Address Line 2',
      accessor: 'address2',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Address Line 3',
      accessor: 'address3',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Province',
      accessor: 'province',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'State',
      accessor: 'state',
      editType: 'inputField',
      options: [],
    },

    {
      Header: 'Country',
      accessor: 'country',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Continent',
      accessor: 'continent',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Zip Code',
      accessor: 'zipCode',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Personnel Email',
      accessor: 'personnelEmail',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Primary Contact',
      accessor: 'contactNo1',
      editType: 'inputField',
      options: [],
    },
    {
      Header: 'Secondary Contact',
      accessor: 'contactNo2',
      editType: 'inputField',
      options: [],
    },

    {
      Header: 'Active ?',
      accessor: 'isActive',
      editType: 'Boolean',
      options: [],
    },
  ];
};

export default allPersonnelColumns;
